module.exports = import("https://esm.sh/@tiptap/extension-bold@2.4.0");;